// Cores de fundo por status da consulta.
export const STATUS_COLORS = {
  SCHEDULED: '#0dcaf0ff',
  CONFIRMED: '#0d6efd',
  CONFIRMED_BY_PATIENT: '#0d6efd',
  PERFORMED: '#198754',
  NO_SHOW: '#6c757d',
  CANCELED: '#dc3545',
};

export const getAppointmentBackground = (status) => STATUS_COLORS[status];

// Converte uma consulta em evento do FullCalendar.
// observacao e appointmentTypeDescription alimentam só o balão de hover e podem
// não vir no DTO do calendário — o balão omite o que estiver ausente.
export const toAppointmentEvent = (appointment) => ({
  title: appointment.nomeDoPaciente,
  start: appointment.dataEHoraDeInicio,
  end: appointment.dataEHoraDeFim,
  extendedProps: {
    consultaId: appointment.id,
    status: appointment.status,
    statusDescription: appointment.statusDescription,
    observation: appointment.observacao,
    appointmentTypeDescription: appointment.appointmentTypeDescription,
  },
  backgroundColor: getAppointmentBackground(appointment.status),
});
